@if(isLoading){
  <afcu-loading [target]="target"/>
} @else {
  <afcu-info [reason]="target"/>
}

